import { AxesOptions, AxisOptions, ScaleTypes } from '@carbon/charts/interfaces'
import { generateHexColorDict } from '../utils'

export const DEFAULT_AXES: AxesOptions<AxisOptions> = {

  left: {
    mapsTo: 'value',
    scaleType: ScaleTypes.LINEAR,
    stacked: true,
    title: 'Value'
  },
  bottom: {
    mapsTo: 'key',
    scaleType: ScaleTypes.TIME,
    title: 'Date'
  },
}

// --

// export const areaChartSetting = [
//   {id: 'Packing'},
//   {id: 'Picking'},
// ]

// export const filterTimes = [
//   {id: 'Past Week'},
//   {id: 'Past Month'},
//   {id: 'Past year'},
// ]

export const donutDict = [
  {
    group: 'With pot',
    value: 25656
  },
  {
    group: 'Without pot',
    value: 20000
  },
  {
    group: 'seeds',
    value: 22222
  },
  {
    group: 'bugs',
    value: 2622
  },
  {
    group: 'tomatoes',
    value: 4233
  },
]

export const heatChartData = [
  {
    letter: 'A',
    month: 'January',
    value: 41
  },
  {
    letter: 'A',
    month: 'February',
    value: 20
  },
  {
    letter: 'B',
    month: 'January',
    value: 10
  },
  {
    letter: 'B',
    month: 'March',
    value: 46
  },
]

export const group = 'group'
export const date = 'date'
export const value = 'value'

export const pickingData = [
{
  [group]: 'Truffaut',
  [date]: '2019-01-01T00:00:00.000Z',
  [value]: 2,
},
{
  [group]: 'Truffaut',
  [date]: '2019-01-04T00:00:00.000Z',
  [value]: 5,
},
{
  [group]: 'Truffaut',
  [date]: '2019-01-06T00:00:00.000Z',
  [value]: 1,
},
{
  [group]: 'Manomano',
  [date]: '2019-01-01T00:00:00.000Z',
  [value]: 1,
},
{
  [group]: 'Manomano',
  [date]: '2019-01-04T00:00:00.000Z',
  [value]: 2.5,
},
{
  [group]: 'Manomano',
  [date]: '2019-01-06T00:00:00.000Z',
  [value]: 3,
},
{
  [group]: 'Dataset 3',
  [date]: '2019-01-01T00:00:00.000Z',
  [value]: 3,
},
{
  [group]: 'Dataset 3',
  [date]: '2019-01-04T00:00:00.000Z',
  [value]: 1,
},
{
  [group]: 'Dataset 3',
  [date]: '2019-01-06T00:00:00.000Z',
  [value]: 2,
},
{
  [group]: 'Dataset 4',
  [date]: '2019-01-06T00:00:00.000Z',
  [value]: 2,
},
]

export const AreaChartOptions = (scale) => ({
  axes: {
    left: {
    mapsTo: 'value',
    scaleType: 'linear',
  },
    bottom: {
      mapsTo: 'date',
      scaleType: 'time',
    },
  },
  timeScale: {
    timeIntervalFormats: {
      daily: {
        primary: 'MMM d',
        secondary: 'MMM d',
      }
    }
  },
  curve: 'curveMonotoneX',
  legend: {
    position: 'top'
  },
  color: {
    scale,
  }
})
export const BarChartOptions = (scale) => ({
  axes: {
    left: {
      stacked: true,
    },
    bottom: {
      mapsTo: 'date',
      scaleType: 'time',
    },
  },
  timeScale: {
    timeIntervalFormats: {
      daily: {
        primary: 'MMM d',
        secondary: 'MMM d',
      }
    }
  },
  legend: {
    position: 'top'
  },
  color: {
    scale,
    colors: ['#fff', '#8fe0e1'],
    gradient:{
      enabled: true,
    }
  }
})

export const HeatChartOptions = {
  axes: {
    bottom: {
      //title: 'letters',
      mapsTo: 'letter',
      scaleType: 'labels',
    },
    left: {
      title: 'Months',
      mapsTo: 'month',
      scaleType: 'labels'
    }
  },
  heatmap: {
    colorLegend: {
      title: 'legend title',
      type: 'quantize'
    }
  },
}

export const Charts = {
  heatChart: {
    data: heatChartData,
    options: {...HeatChartOptions, title: '', }
  },
  // donut: computed(Charts.useDonut(dummyDonutDict)),
  area: {
    data: pickingData,
    options: {...AreaChartOptions(generateHexColorDict(donutDict)), title: ''}
  },
  bar: {
    data: pickingData,
    options: {...BarChartOptions(generateHexColorDict(pickingData)), title: ''}
  }
}
